module.exports = __webpack_public_path__ + "blissweb-md.67dbc344fce3d0900a88.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/BlissWeb-Md/blissweb-md.svg
// module id = 390
// module chunks = 5